import React from "react";
import Popup from "../Component/Popup";
import Header from "../Component/Header";
import HomeSlider from "../Component/HomeSlider";
import OnlineRegistration from "../Component/OnlineRegistration";
import Footer from "../Component/Footer";
import Message from "../Component/Message";
import News from "../Component/News";
import Events from "../Component/Events";
import Gallery from "../Component/Gallery";
import Form from "../Component/Form";
import StaffBirthday from "../Component/StaffBirthday";
import StudentBirthday from "../Component/StudentBirthday";
import Campuscare from "../Component/Campuscare";
import { Link } from "react-router-dom";
const Home = () => {
  return (
    <>
      <Popup />
      <Header />
      <Campuscare />
      <OnlineRegistration />
      <HomeSlider />
      <div class="aboutmidsec padded-sec">
        <div class="button">
          <a
            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/pdf/MandatoryDisclosureDetails.pdf"
            target="_blank"
          >
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/cbse.gif"
              alt="Gayatri International School"
            />
            <p>
              CBSE <br /> disclosure
            </p>
          </a>
        </div>
        <div class="button">
          <a href="/" target="_blank">
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/online.gif"
              alt="Gayatri International School"
            />
            <p>
              online
              <br />
              payment
            </p>
          </a>
        </div>
        <div class="button">
          <a
            href="https://portalguidelines.campuscare.info/index.html#GISFUP"
            target="_blank"
          >
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/pphelp.gif"
              alt="Gayatri International School"
            />
            <p>
              Portal <br />
              (HELP)?
            </p>
          </a>
        </div>
        <div class="phone">
          <a href="tel:+919519213002">
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/phone.gif"
              alt="Gayatri International School"
            />
            Enquiry
          </a>
        </div>
        <div class="button">
          <a href="/" target="_blank">
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/alumni.gif"
              alt="Gayatri International School"
            />
            <p>
              Alumnae
              <br />
              Registration
            </p>
          </a>
        </div>
        <div class="button">
          <a href="/">
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/book.gif"
              alt="Gayatri International School"
            />
            <p>
              Book <br />
              List
            </p>
          </a>
        </div>
        <div class="button">
          <a href="/">
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/bus.gif"
              alt="Gayatri International School"
            />

            <p>
              Bus
              <br />
              Route
            </p>
          </a>
        </div>
      </div>
      <div className="about padding-section">
        <div className="container-fluid">
          <div className="row">
            <div className="col-xl-4">
              <div className="abt-gif">
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/about.gif"
                  className="img-fluid"
                />
              </div>
            </div>
            <div className="col-xl-8">
              <div className="title">
                <p>ABOUT US</p>
                <h1>Gayatri International School</h1>
              </div>
              <p>
                GAYATRI INTERNATIONAL SCHOOL,Arrah Paharpur is a premier
                co-educational day school under the aegis of Gayatri Devi
                Educational Society has been envisioned to provide learners an
                avant garde education to enable them to sprout, grow and blossom
                into physically fit, intellectually curious, socially
                intelligent, technologically savvy and morally sound individuals
                in a nurturing and caring environment. GIS intends to provide
                learners an ideal platform to engage in fruitful pursuits to
                widen their knowledge.
              </p>
              <button className="readmore"> Read More</button>
            </div>
          </div>
        </div>
      </div>
      <div className="message padding-section">
        <div className="container-fluid">
          <div className="row">
            <div className="col-xl-6">
              <div className="">
                <div className="title text-center mb-4">
                  <p>school administration</p>
                  <h2>out torch bearers</h2>
                </div>
                <div className="d-flex">
                  <div className="admin-blk">
                    <div>
                      <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/chairman.jpg" />
                      Chairman
                    </div>
                    Mr. Manoj Agarwal
                  </div>
                  <div className="admin-blk">
                    <div>
                      <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/chairperson.jpg" />
                      Chairperson
                    </div>
                    Mrs. Vatsala Agarwal
                  </div>
                  <div className="admin-blk">
                    <div>
                      <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/principal.jpg" />
                      Principal
                    </div>
                    Mr. Raj Kumar Sharma
                  </div>
                  <div className="admin-blk">
                    <div>
                      <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/academic_head.jpg" />
                      Academic Head
                    </div>
                    Mrs. Abha Patel
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-6">
              <div className="title text-center mb-4">
                <p>From the desk of</p>
                <h2>Message Section</h2>
              </div>
              <div className="message-blk">
                <Message />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid padding-section">
        <div className="row">
          <div className="col-xl-7">
            <div className="title text-center mb-4">
              <p>EVENTS SECTION</p>
              <h2>Upcoming Events</h2>
            </div>
            <Events />
            <Link to="/Events">
              <button className="readmore m-auto d-block mt-4">
                Read More
              </button>
            </Link>
          </div>
          <div className="col-xl-5 mt-xl-0 mt-lg-5 mt-md-5 mt-sm-5 mt-xs-5">
            <div className="title text-center mb-4">
              <p>News Section</p>
              <h2>Latest News</h2>
            </div>
            <div className="news">
              <News />
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid padding-section birthday-bg">
        <div className="row">
          <div className="col-md-12">
            <div className="title text-center mb-4">
              <p>BORN ON THIS DAY</p>
              <h2>TODAY’S BIRTHDAY</h2>
            </div>
          </div>
          <div className="col-md-6">
            <div className="title text-center mb-4">
              <p>Teacher Birthday</p>
            </div>
            <StaffBirthday />
          </div>
          <div className="col-md-6">
            <div className="title text-center mb-4">
              <p>Student Birthday</p>
            </div>
            <StudentBirthday />
          </div>
        </div>
      </div>

      <div className="container-fluid padding-section gallery-bg">
        <div className="row">
          <div className="col-md-12">
            <div className="title text-center mb-4">
              <p>Media</p>
              <h2>Photo Gallery</h2>
            </div>
          </div>
          <div className="col-md-12">
            <Gallery />

            <Link to="/Gallery">
              <button className="readmore m-auto d-block mt-4">
                Read More
              </button>
            </Link>
          </div>
        </div>
      </div>
      <div className="ftr-contact">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-5 col-md-12 col-sm-12 pos-rel">
              <div className="title text-left mb-4">
                <h2>Get In Touch</h2>
              </div>
              <Form />
              {/* <form>
                <div className='w-50'>
                  <label>Name</label>
                  <input type="text" />                  
                </div>
                <div className='w-50'>
                  <label>Contact</label>
                  <input type="text" />
                </div>
                <div className='w-100'>
                  <label>Email Id</label>
                  <input type="text" />
                </div>
                <div className='w-100'>
                  <label>Message</label>
                  <input type="text" />
                </div>
                <div className='w-100'>
                  <input type="submit" value="SUBMIT"></input>
                </div>
              </form> */}
            </div>
            <div className="col-lg-7 col-md-12 col-sm-12 pos-rel">
              <div className="title text-right mb-4">
                <h2>Our Partners</h2>
              </div>
              <div className="partner">
                <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/partner1.png" />
                <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/partner2.png" />
                <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/partner3.png" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Home;
